import { useTransition } from 'stimulus-use'
import DropdownController from "./dropdown_controller"

export default class extends DropdownController {
  static targets = ["placeholder", "list", "input"]
  static values = { loaded: Boolean }

  eventCreated = false
  prefix = this.getPrefix(this.menuTarget.id)

  connect() {
    console.log('connect1')
    const values = this.getInputTargetsValues()

    if (values.length < 0) {
      this.placeholderTarget.classList.add('hidden')
    }

    this.startSelect(values)
    this.loadedValue = true

    useTransition(this, { element: this.menuTarget })
  }

  toggleInput() {
    console.log("menu toggle")
    this.menuTarget.classList.toggle('hidden')
  }

  hide() {
    this.toggleInput()
  }

  select(event) {
    const regex = new RegExp("^" + this.prefix + "_")
    const id = event.params.id.replace(regex, "")

    this.selectHelper(this.prefix, id)
  }

  startSelect(values) {
    values.forEach(element => {
      document.getElementById(this.prefix + '_tick_' + element)?.click()
    })
  }

  selectHelper(prefix, id) {
    const show = document.getElementById(prefix + '_show_' + id)
    const tick = document.getElementById(prefix + '_tick_' + id)
    // pole formularza
    let values = this.getInputTargetsValues()
    if (tick.checked) {
      show.classList.remove('hidden')
      show.classList.add('flex')

      // zabezpieczenie by nie dodawać kilka razy tego samego elementu
      if (values.indexOf(id) === -1) {
        values.push(id)
      }
    } else {
      show.classList.add('hidden')
      show.classList.remove('flex')
      this.removeInputTargetValue(id)
      values = values.filter(e => e !== id)
    }

    // chowanie placeholdera jeśli jest wybrana co najmniej jedna opcja
    if (values.filter(n => n).length > 0) {
      this.placeholderTarget.classList.add('hidden')
    } else {
      this.placeholderTarget.classList.remove('hidden')
    }

    values.forEach(value => {
      this.setInputTargetValue(value)
    })
  }

  remove(event) {
    document.getElementById(this.prefix + '_tick_' + event.params.id).click()
  }

  getPrefix(target) {
    const index = target.lastIndexOf('_')
    const prefix = target.slice(0, index)
    return prefix
  }

  getSuffix(target) {
    const index = target.lastIndexOf('_')
    const suffix = target.slice(index + 1)
    return suffix
  }

  getInputTargetsValues() {
    const targets = this.inputTargets.map(t => t.value).filter(n => n)
    return targets
  }

  // ustawiamy wartosc pola jesli nie istnieje juz takie pole z ta wartoscia
  setInputTargetValue(value) {
    const existingField = this.inputTargets.find(target => target.value === value)
    if (existingField === undefined) {
      const emptyField = this.inputTargets.find(target => !target.value)
      if (emptyField) {
        emptyField.setAttribute('value', value)
      } else {
        this.createNewArrayInput()
        this.setInputTargetValue(value)
      }
    }
  }

  // ustawiamy puste value dla pola ktore znajdziemy na podstawie value
  removeInputTargetValue(value) {
    const existingField = this.inputTargets.find(target => target.value === value)
    existingField.setAttribute('value', '')
  }

  createNewArrayInput() {
    const target = this.inputTargets[0]
    const newTarget = target.cloneNode()

    newTarget.setAttribute('value', '')
    target.after(newTarget)
  }

  toggle(event) {
    event.currentTarget.classList.toggle('hidden')
  }
}
